"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useIconProps = require("../useIconProps");

var Close = function Close(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 16 16"
  }, (0, _useIconProps.useIconProps)(props)), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.14 11.184a.48.48 0 00.68.678l3.179-3.18 3.202 3.203a.48.48 0 00.68-.679L8.677 8.004l3.184-3.185a.48.48 0 10-.678-.678L7.998 7.325 4.836 4.162a.48.48 0 10-.68.678L7.32 8.004l-3.18 3.18z"
  }));
};

Close.displayName = 'Close';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Close.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

var _default = Close;
exports.default = _default;